// XPEN-3794: a submitted expense report is read-only for its employee, except what was denied.
// The API decides it and says so: read_only_for_employee on the report, report_editable_lines
// ("all" or "denied") on its invoice, and 409 expense_report_submitted on a refused change.
// A denied expense can still be corrected and sent again, or deleted. A whole report is
// deleted before submission, or once every expense on it was refused (the list's can_delete);
// otherwise a submitted one is returned to its employee first.

const DELETABLE_REPORT_STATUSES = ['Pending', 'Pending_Exception_Approval'];

export const canDeleteReport = (account) => (typeof account?.can_delete === 'boolean'
  ? account.can_delete
  : DELETABLE_REPORT_STATUSES.includes(account?.status));

export const isExpenseReadOnly = (account, expense) =>
  account?.read_only_for_employee === true && expense?.status !== 'Denied';

export const canEditReportLine = (invoice, line) =>
  invoice?.report_editable_lines !== 'denied' || line?.Status === 'Denied';

export const reportEditLockErrorKey = (error) =>
  error?.response?.data?.error === 'expense_report_submitted' ? 'report_edit_lock.submitted' : null;
